import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { articles } from '../data/articles';
import { NewsCard } from './NewsCard';
export function News() {
  return <section id="news" className="py-24 bg-white" data-id="element-231" data-mp="3girctwu0wup7">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-232" data-mp="3gk2hdyvam6hd">
        <div className="flex justify-between items-end gap-6 mb-12 border-b border-slate-200 pb-6" data-id="element-233" data-mp="3li41mn4ggbuf">
          <div data-id="element-234" data-mp="d2k95qblyxgf">
            <h2 className="font-serif text-4xl font-bold text-pac-navy mb-2" data-id="element-235" data-mp="d1r7v4vf505o">
              News & Updates
            </h2>
            <div className="w-16 h-1 bg-pac-red" data-id="element-236" data-mp="i26nk336ajqt" />
          </div>
          <Link to="/news" className="hidden md:inline-flex items-center gap-2 text-pac-blue font-bold hover:text-pac-navy transition-colors focus:outline-none focus:ring-2 focus:ring-pac-gold focus:ring-offset-2 rounded" data-id="element-237" data-mp="3awny75nacne">
            View All News <ArrowRight className="h-4 w-4" data-id="element-238" data-mp="10r3fw1f0f26e" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-239" data-mp="2xrivhvc583tp">
          {articles.map(article => <NewsCard key={article.slug} article={article} data-id="element-240" data-mp="2ssxqlily4vyx" />)}
        </div>

        <div className="mt-10 md:hidden" data-id="element-241" data-mp="37hlm5ovsl5ov">
          <Link to="/news" className="inline-flex items-center gap-2 text-pac-blue font-bold hover:text-pac-navy transition-colors focus:outline-none focus:ring-2 focus:ring-pac-gold focus:ring-offset-2 rounded" data-id="element-242" data-mp="37idi50tax5fo">
            View All News <ArrowRight className="h-4 w-4" data-id="element-243" data-mp="3bjfi5jv1llip" />
          </Link>
        </div>
      </div>
    </section>;
}